(() => {
  const init = root => {
    root.querySelectorAll('[data-kbs-category-picks]').forEach(section => {
      if (section.dataset.picksReady) return;
      section.dataset.picksReady = 'true';
      const tabs = [...section.querySelectorAll('[role="tab"]')];
      const select = tab => {
        tabs.forEach(button => {
          const active = button === tab;
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(button.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          select(tabs[next]);
          tabs[next].focus();
        });
      });
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target.parentElement || document));
})();
